import 'core-js/modules/es.promise.js';
import { __awaiter } from '../../_virtual/_tslib.js';
import * as uuid from 'uuid';
import { DataUrlToFile } from './data-url-to-file.js';

class GenerateThumbnail {
  execute(data) {
    return __awaiter(this, void 0, void 0, function* () {
      const thumbnailFileName = `${data.name}_thumbnail.png`;
      const thumbnail = yield this.getThumbnail(data.url);
      const thumbnailFile = yield new DataUrlToFile().execute(thumbnail, thumbnailFileName);
      return {
        id: uuid.v4(),
        name: thumbnailFileName,
        mimeType: thumbnailFile.type,
        file: thumbnailFile
      };
    });
  }
  getThumbnail(url) {
    return __awaiter(this, void 0, void 0, function* () {
      if (typeof window === 'undefined') {
        return '';
      }
      const {
        default: generatePdfThumbnails
      } = yield import('pdf-thumbnails-generator');
      const thumbnails = yield generatePdfThumbnails(url, 211);
      const thumbnail = thumbnails[0].thumbnail;
      return thumbnail;
    });
  }
}

export { GenerateThumbnail };
